/**
 * @file Barrel export for ItemSeparator component
 * @module features/notes/components/ItemSeparator
 */

export { default } from "./ItemSeparatorView";
